<template>
  <v-container :class="isSPSize ? 'sp' : ''">
    <v-row>
      <v-col col="12">
        <h1 :class="h1Style" class="title-border">
          Terms of Use
        </h1>
        <p>
           The Terms of Use (the &quot;Terms&quot;) set forth the terms and conditions for the provision of the Service(the &quot;Service&quot;) provided by Paike (the &quot;Company&quot;), and the rights and obligations between the Company and the registered Users(the &quot;Users&quot;). Users must agree to the Terms by reading the entirety before using the Service.
        </p>
        <p>
          Article 1 Application
        </p>
        <p>
          The Terms apply to all relationships between User and the Company related to the use of the Services. In addition to the Terms, individual terms of use and rules of use sent by the Company through e-mail website etc. shall also constitute an integral part of the Terms.
        </p>
        <p>
          Article 2 Description of the Services.
        </p>
        <ol class="mb-3">
          <li>The primary goal of the Services is to be a platform that provides the matching service between any person whoever travels from abroad (the &quot;Traveler&quot;) and any person whoever lives or stays for a long time(the &quot;Local&quot;). The Company does not ensure that there is no possibility that a non-traveler may utilize the Services as a traveler, or a non-local person may utilize the Services as a Local.</li>
          <li>The Services shall not be used for any purpose other than the international exchange intended by the Company, such as commercial purposes (including sales of goods, sending Users to specific services/stores, advertisements, etc.), recruitments of religions and specific organizations, and the sexual purpose.</li>
        </ol>
        <p>
          Article 3 Registration for use
        </p>
        <ol class="mb-3">
          <li>
            The Registration for use shall be completed when the person who applies for registration (“Registration Applicant”), having agreed to the Terms, applies for use of the Services and the Company approves thereof. If the Company determines that a Registration Applicant falls under or is likely to fall under any of the following, the Company may refuse, cancel or suspend the registration for use of the Registration Applicant. The Company does not take any liability for disclosure of the information.
            <ol class="mb-3 list_parentheses">
              <li>If the Registration Applicant declared any matter that is not true in User registration procedures;</li>
              <li>If the Registration Applicant is a person whose the registration for the Services was refused, canceled or suspended in the past;</li>
              <li>If the Company believes that the Registration Applicant is likely to violate the Terms;</li>
              <li>When the Registration Applicant does not cooperate with the Company in providing feedback, etc. after using the Services;</li>
              <li>If the Company determines that the Registration Applicant acts unpleasantly to any User, the Company Staff or third party in using the Services;</li>
              <li>If the Company otherwise determines that registration of the Registration Applicant is not appropriate.</li>
            </ol>
          </li>
          <li>Services shall only be available to any person aged 18 years of age or older. Registration by a representative is not permitted.</li>
          <li>A person who belongs to or is related to anti-social forces such as organized crime groups may not register for the use of the Service.</li>
          <li>The User may not transfer or lend the status based on the registration in paragraph 1 to a third party in any case.</li>
          <li>In the event that a change is made to the items registered with the Company, the User must promptly notify the Company of the change by the method specified by the Company. The Company will not be liable for any disadvantage or damage to the User due to failure to submit a notification.</li>
          <li>Completion of the Registration for Use under Paragraph 1 shall not guarantee the use of the Services.</li>
        </ol>
        <p>
          Article 4 Change of the Terms of Use
        </p>
        <ol class="mb-3">
          <li>
            The Company may change the Terms of Use at the Company's discretion in the following cases.
            <ol class="mb-3 list_parentheses">
              <li>When a change in the Terms of Use conforms to the general interests of the User.</li>
              <li>When the change in the Terms of Use is not contrary to the purpose of the contract and is reasonable in light of the necessity of the change, the significance of the changed content, the content of the change, and other circumstances related to the change.</li>
            </ol>
          </li>
          <li>Upon the change of the Terms of Use set forth in the preceding paragraph, the Company shall change the Terms of Use by one month prior to the effective date of the changed Terms of Use, and shall provide a notice on the Company's website.</li>
        </ol>
        <p>
          Article 5 Changes to Details of the Services;
        </p>
        <ol class="mb-3">
          <li>The Company may change the contents of the Services or discontinue the provision of the Services without notice to User.</li>
          <li>The Company shall in no event be liable for any disadvantage or damage incurred by the User or any third party as a result of measures taken by the Company pursuant to the preceding paragraph.</li>
        </ol>
        <p>
          Article 6 Handling of Users &amp;&#39; Personal Information, etc.
        </p>
        <p>
          The Company shall appropriately handle names, email addresses, and other personal information obtained from Users with regard to use of the Services, pursuant to these Terms of Use and the Privacy Policy separately stipulated by the Company.
        </p>
        <p>
          Article 7 Consent to Provision of Personal Information to Third Parties
        </p>
        <p>
          Users consent in advance to the Company’s provision of User information to third parties with regard to the use of the Services pursuant to the Privacy Policy separately stipulated by the Company.
        </p>
        <p>
          Article 8 Ownership of Intellectual Property Rights and Other Rights
        </p>
        <ol class="mb-3">
          <li>Ownership and Intellectual Property Rights (copyright, patent rights, utility model rights, design rights, trademark rights, and any other intellectual property rights.) in all photographs, data, illustrations, software, materials, designs, diagrams and other items pertaining to the Services, all other rights belong to the Company.</li>
          <li>The license to use the Services under the User registration set forth in the Terms shall not be a license to use or use any intellectual property rights or any other rights owned or used by the Company.</li>
          <li>The User shall not conduct any act which infringes or is likely to infringe intellectual property rights and any other rights held by the Company or a third party for any reason.</li>
          <li>The User grants the Company a worldwide, non-exclusive, royalty-free, sub-licensable and transferable license to Use reproduce, distribute, prepare derivative works from, display and perform the photographs, illustrations, feedback (including answers to the questionnaire) and reports and other data the User may provide to the Company. The method of providing the information shall be irrespective of the form, such as sending by e-mail, uploading to the website operated by the Company and SNS managed by the Company.</li>
          <li>The User agrees not to exercise the moral rights of the author against the Company or any person to whom the Company has succeeded or granted rights.</li>
        </ol>
        <p>
          Article 9 Prohibited Matters
        </p>
        <ol class="mb-3">
          <li>
            When using the Services, Users may not directly or through a third party engage in any act that falls under, or that is likely to fall under, any of the following:
            <ol class="mb-3 list_parentheses">
              <li>Act of violating the Terms, rules established by the Company or instructions from the Company;</li>
              <li>The act of providing the Company false information in relation to User registration information;</li>
              <li>A criminal act, an act that is offensive to public order or morals or an act in violation of laws and regulations;</li>
              <li>Act of using the Services for any purpose other than the international exchange intended by the Company, such as commercial purpose (including sales of goods, sending Users to specific services/stores, advertisements, etc.), recruitments of religions and specific organizations, and the sexual purpose;</li>
              <li>Act of using the Services for use of the Services for own or third party business/activities, regardless of profit or non-profit;</li>
              <li>Act that cause discomfort to our staff, Users or third parties;</li>
              <li>Any act that infringes on an intellectual property right, portrait right, privacy right, or any other right or interest of the Company, another User, or a third party;</li>
              <li>The act of transmitting information that includes a computer virus or other harmful computer program;</li>
              <li>Act of reporting or providing false or inaccurate information to the Company, the User or a third party in using the Services;</li>
              <li>Any act that causes excessive load on the server of the Services, or any act that hinders the operation of the Services or on the network or system;</li>
              <li>Act that hinders or might hinder our business or the operation of the Services</li>
              <li>Act of using the Services or information or materials obtained through the Services for commercial purposes or other purposes unrelated to the Services;</li>
              <li>Act of using the Services other than as permitted by the Company;</li>
              <li>Any act that encourages or assists others to engage in illegal acts;</li>
              <li>Any act that defames or damages trust in the Company, the staff or others; or</li>
              <li>Any other act that the Company determines to be inappropriate.</li>
            </ol>
          </li>
          <li>
            If the Company determines that any act of a User falls under any of the foregoing, without any notice to the User, the Company may delete all or a portion of registration information of such User.
          </li>
          <li>
            The Company shall not be liable for any damage suffered as a result of the Company’s response pursuant to the foregoing paragraphs.
          </li>
        </ol>
        <p>
          Article 10 Disclaimers and Indemnification
        </p>
        <ol class="mb-3">
          <li>The Company makes no warranties regarding matters such as the completeness, accuracy, usefulness, currency, and truthfulness of the information provided by the Services. The Company shall not be responsible for any results that arise from any act that a User carries out based on his/her judgment pursuant to the information provided by the Services.</li>
          <li>The Users shall use the Services on their own responsibility, and the Company shall not be liable for any matters relating to the Users in the Services.</li>
          <li>If the Company is to bear liability for any reason, it shall not be liable for compensation for damage by the Company’s negligence that exceeds the amount of the consideration for the related Contents. Further, the Company shall not be liable for incidental damage, indirect damage, special damage, future damage, or damage related to lost earnings and profits.</li>
          <li>The User acknowledges that the Company and the Services only provide a place for matching between Users, and the matching itself as well as any transaction, dispute, etc. arising between Users or between Users and a third party after the matching shall be settled at their own expense between the parties and the Company shall have no responsibility.</li>
          <li>With respect to the use of the Services by the User, if another User or other third party claims damages to the Company based on the intentional or negligence (including slight negligence) of the User. , The User is obliged to cooperate with us to resolve the case and to compensate for any damages and costs involved in the claim.</li>
        </ol>
        <p>
          Article 11 Temporary Suspension of Services
        </p>
        <ol class="mb-3">
          <li>
            the Company may suspend the provision of Services without prior notice to User if:
            <ol class="mb-3 list_parentheses">
              <li>When performing maintenance on the Services and the systems and related equipment incidental thereto;</li>
              <li>When the communication line, software service or electric power used by the Company becomes unavailable;</li>
              <li>When a natural disaster such as earthquake, typhoon, flood, tsunami or any other emergency situation occurs, or because there is a likelihood of such an occurrence, there is a demand or instruction to restrict communication under laws, regulations, or directives;</li>
              <li>Responding to laws and regulations, or guidance or requests from administrative authorities;</li>
              <li>In the event that the number of subscriptions for the Services exceeds the capacity of the Company to respond to the Services;</li>
              <li>When the provision of the Services becomes impossible due to other physical or technical reasons;</li>
            </ol>
          </li>
          <li>Even if there is a delay or temporary suspension of the provision of the Services, the Company shall not be liable for damage suffered by a User or a third party from the same.</li>
        </ol>
        <p>
          Article 12 Withdrawal
        </p>
        <p>
          If the User wishes to terminate the use of the Services or cancel the registration (the &quot;Withdrawal&quot;), the User shall declare to the Company in accordance with the method prescribed by the Company.
        </p>
        <p>
          Article 13 Assignment
        </p>
        <p>
          A User may not assign, transfer, provide as collateral, or dispose of, his/ her status under the service agreement or rights and duties under these Terms of Use without the prior written consent of the Company.
        </p>
        <p>
          Article 14 Governing Law and Jurisdiction
        </p>
        <ol class="mb-3">
          <li>The Terms shall be governed by the laws of Japan.</li>
          <li>In the event of any dispute arising in connection with the Services, regardless of dispute, the Tokyo District Court shall be the exclusive agreement jurisdictional court of the first instance.</li>
        </ol>
        <p class="text-right">End</p>
        <p class="text-right">Date of creation of Terms of Use</p>
        <p class="text-right">March 27, 2020</p>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" class="text-center">
        <v-btn
          rounded
          large
          dark
          align-items="center"
          color="gray"
          width="250"
          class="font-weight-bold text-capitalize"
          @click="existsHistory ? $router.go(-1) : $router.push('/en')"
        >
          {{ existsHistory ? 'Back' : 'Top' }}
        </v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  computed: {
    h1Style() {
      return this.isSPSize
        ? 'font-h1-sp font-weight-bold mb-3'
        : 'font-h1-pc font-weight-bold mb-5'
    },
    isSPSize() {
      return this.$vuetify.breakpoint.name === 'xs'
    },
  },
  data: () => ({
    existsHistory: false,
  }),
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.existsHistory = from.name != null
    })
  },
}
</script>

<style lang="stylus" scoped>
p
  line-height 1.5
  font-size 15px

.sp
  p, ul, ol
    font-size 12px

ol.list_parentheses
  padding 0 0 0 2em
  margin 0
  li
    list-style-type none
    list-style-position inside
    counter-increment cnt
    padding-left 1.5em
    text-indent -1.5em
    &:before
      display marker
      content "(" counter(cnt) ") "

</style>